import { get } from './apiClient';
import { urls } from './urlService';

// /site/pincodes/check?pincode=XXXX -> { pincode, deliverable, city, state, message, vendors:[{id,name,shopName}] }
export function checkPincode(pincode) {
  return get(`${urls.pincodeCheck}${pincode}`);
}

export function verifyPincodeProduct(pincode, productId) {
  const params = new URLSearchParams({ pincode, productId });
  return get(`${urls.pincodeVerify}?${params.toString()}`);
}